module.exports = __webpack_public_path__ + "static/media/share-tutorial.d3985ee2.mp4";